import { FC } from 'react';
import { Link } from 'react-router';
import { Text } from '@connect-x-app/hybrid-ui';
import { COLORS } from '@connect-x-app/shared-ui';
import classnames from 'classnames';

import './breadcrumb.scss';

type Props = {
  disabled: boolean;
  name: string;
  url: string;
};

export const BreadCrumb: FC<Props> = ({ disabled, name, url }) => {
  return (
    <li className="nav-bar-li">
      <Link className={classnames(disabled ? 'disabled-link' : undefined)} to={url}>
        <Text as="span" color={COLORS.zulu.$08} size="XL" uppercase weight={disabled ? 'bold' : 'regular'}>
          {name}
        </Text>
      </Link>
    </li>
  );
};
